import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_SETTINGS } from '../../../constants/settings';
import { initialSettings, ISettings } from './models';

interface IState {
  settings: ISettings;
  isDraftReady: boolean;
}

const initialState: IState = {
  settings: initialSettings,
  isDraftReady: false
};

const videoReadingDraftSettingsSlice = createSlice({
  name: 'videoReadingDraftSettings',
  initialState,
  reducers: {
    /**
     * Обновление таймера
     * @param state Состояне
     * @param root0 Пропсы
     * @param root0.payload Новое значение таймера
     */
    updateDraftSettings: (
      state,
      { payload }: { payload: Partial<ISettings> }
    ) => {
      if (payload.fontSize !== undefined) {
        return {
          ...state,
          settings: {
            ...state.settings,
            ...payload,
            lineHeight: payload.fontSize * DEFAULT_SETTINGS.line_height_factor
          }
        };
      }

      return {
        ...state,
        settings: {
          ...state.settings,
          ...payload
        }
      };
    },

    /** Ресет настроек */
    resetDraftSettings: () => initialState
  }
});

export const { resetDraftSettings, updateDraftSettings } =
  videoReadingDraftSettingsSlice.actions;
export const { reducer: videoReadingDraftSettingsReducer } =
  videoReadingDraftSettingsSlice;
